export const isValidHexColor = (color?: string): boolean => {
   if (!color) return false;

   return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color);
};

/** #abc → #aabbcc. Authorize.net's hosted form only takes the six-digit form. */
const expandShorthandHex = (color: string): string =>
   color.length === 4
      ? `#${color
           .slice(1)
           .split('')
           .map((channel) => channel + channel)
           .join('')}`
      : color;

/**
 * Accent colour handed to the Authorize.net hosted card form (its hostedProfileHeadingBgColor
 * setting, which despite the name paints the field underlines and the Save button). Read off
 * the live theme vars so an org-themed checkout hands the hosted page the same primary the
 * surrounding page is already using, instead of Authorize.net's stock grey.
 *
 * Returns undefined when the var is missing or isn't a plain hex — the API omits the setting
 * in that case rather than sending something Authorize.net would reject.
 */
export const getHostedFormAccentColor = (): string | undefined => {
   if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') return undefined;

   const styles = window.getComputedStyle(document.documentElement);
   // Org primary first: checkout is org-themed, and the modal opens on top of it.
   for (const varName of ['--color-org-primary', '--color-primary']) {
      const value = styles.getPropertyValue(varName).trim();
      if (isValidHexColor(value)) return expandShorthandHex(value).toUpperCase();
   }
   return undefined;
};
